export enum InTermsOf {
  base_ccy,
  quote_ccy,
}

export enum InTermsOfRio {
  ccy_source,
  ccy_dest,
}

export enum FlagEnum {
  "send_onboarding" = "send_onboarding",
  "institutional" = "institutional",
  "admin_transfers" = "admin_transfers",
  "ccy_conversion_client" = "ccy_conversion_client",
  "ccy_conversion_broker" = "ccy_conversion_broker",
  "api_access" = "api_access",
  "no_currency_field" = "no_currency_field",
  "batch_orders" = "batch_orders",
  "hide_spread_selector" = "hide_spread_selector",
  "ccy_conversion_super_broker" = "ccy_conversion_super_broker",
  "ccy_conversion_mex_dollar" = "ccy_conversion_mex_dollar",
  "leads" = "leads",
  // "mex_dollar_admin" = "mex_dollar_admin",
}

export enum Locations {
  "/api-docs" = "/api-docs",
  "/api-management" = "/api-management",
  "/terms-and-conditions" = "/terms-and-conditions",
  "/admin-summary" = "/admin-summary",
  "/onboarding" = "/onboarding",
  "/documentation" = "/documentation",
  "/access-denied" = "/access-denied",
  "/ccy-conversion/destination-bank-accounts-router" = "/ccy-conversion/destination-bank-accounts-router",
  "/ccy-conversion/mm" = "/ccy-conversion/mm",
  "/ccy-conversion/destination-bank-accounts" = "/ccy-conversion/destination-bank-accounts",
  "/ccy-conversion/place-order" = "/ccy-conversion/place-order",
  "/ccy-conversion/place-order-mexdolar" = "/ccy-conversion/place-order-mexdolar",
  "/ccy-conversion/orders" = "/ccy-conversion/orders",
  "/ccy-conversion/order/:id" = "/ccy-conversion/order/:id",
  "/ccy-conversion/orders/:id" = "/ccy-conversion/orders/:id",
  "/ccy-conversion/settings" = "/ccy-conversion/settings",
  "/login" = "/login",
  "/sign-up" = "/sign-up",
  "/verify-email" = "/verify-email",
  "/reset-password" = "/reset-password",
  "/send-onboarding" = "/send-onboarding",
  "/" = "/",
  "/admin" = "/admin",
  "/admin/onboardings" = "/admin/onboardings",
  "/admin/orders" = "/admin/orders",
  "/admin/transfers" = "/admin/transfers",
  "/admin/accounts" = "/admin/accounts",
  "/admin/users" = "/admin/users",
  "/admin/analytics" = "/admin/analytics",
  "/admin/mexdolar-orders" = "/admin/mexdolar-orders",
  "/ccy-conversion/place-order-batch" = "/ccy-conversion/place-order-batch",
  "/admin/fe-version" = "/admin/fe-version",
  "/admin/create-manual-order" = "/admin/create-manual-order",
  "/admin/quote-stream" = "/admin/quote-stream",
  "/cockpit" = "/cockpit",
  "/leads" = "/leads",
  "/admin/compliance" = "/admin/compliance",
}

export const Titles = {
  [Locations["/api-docs"]]: "API Docs",
  [Locations["/admin/onboardings"]]: "Onboardings",
  [Locations["/admin/analytics"]]: "Analytics",
  [Locations["/api-management"]]: "API Management",
  [Locations["/admin/users"]]: "User Management",
  [Locations["/terms-and-conditions"]]: "Terms and Conditions",
  [Locations["/admin/orders"]]: "Orders",
  [Locations["/admin/transfers"]]: "Transfers",
  [Locations["/admin/accounts"]]: "Destination Accounts",
  [Locations["/admin/fe-version"]]: "FE Version",
  [Locations["/admin-summary"]]: "Admin",
  [Locations["/"]]: "Dashboard",
  [Locations["/onboarding"]]: "",
  [Locations["/access-denied"]]: "Access denied",
  [Locations["/login"]]: "",
  [Locations["/verify-email"]]: "",
  [Locations["/sign-up"]]: "",
  [Locations["/reset-password"]]: "Reset Password",
  [Locations["/documentation"]]: "Documentation",
  [Locations["/ccy-conversion/mm"]]: "Order's Board",
  [Locations["/ccy-conversion/place-order"]]: "Place Order",
  [Locations["/ccy-conversion/order/:id"]]: "Place Order",
  [Locations["/ccy-conversion/orders"]]: "Orders",
  [Locations["/ccy-conversion/settings"]]: "Settings",
  [Locations["/ccy-conversion/orders/:id"]]: "Order",
  [Locations["/ccy-conversion/destination-bank-accounts"]]:
    "Destination Accounts",
  [Locations["/send-onboarding"]]: "Onboardings",
  [Locations["/ccy-conversion/destination-bank-accounts-router"]]:
    "Destination Accounts",
  [Locations["/admin"]]: "Admin",
  [Locations["/ccy-conversion/place-order-batch"]]: "Batch Orders",
  [Locations["/ccy-conversion/place-order-mexdolar"]]: "Place Order (MexDolar)",
  [Locations["/admin/mexdolar-orders"]]: "MexDolar Orders",
  [Locations["/admin/create-manual-order"]]: "Manual Order",
  [Locations["/admin/quote-stream"]]: "Quote Stream",
  [Locations["/cockpit"]]: "Dashboard",
  [Locations["/leads"]]: "Leads",
  [Locations["/admin/compliance"]]: "Compliance",
};

export enum Roles {
  "admin" = "admin",
}

export enum FillStateOptions {
  "NONE" = "NONE",
  "PARTIAL" = "PARTIAL",
  "FULL" = "FULL",
}

export enum OrderClassName {
  ActiveTriggerOrder = "ActiveTriggerOrder",
  PassiveSingleOrder = "PassiveSingleOrder",
  IcebergOrder = "IcebergOrder",
}

export enum OrderTabOptions {
  orders,
  trades,
}

export enum OrderOptions {
  active,
  past,
}

export enum DestinationBankAccountTabOptions {
  MexicanBankAccount,
  UsBankAccount,
  CryptoWallet,
}

export enum DestinationBankAccountTabOptionsRio {
  "Mexico" = "Mexico",
}

export enum Sides {
  "BUY" = "BUY",
  "SELL" = "SELL",
}

export enum Partners {
  "KAPITAL" = "KAPITAL",
}

export enum Modals {
  "NoModal" = "NoModal",
  "ViewBankAccountModal" = "ViewBankAccountModal",

  "SendKyb" = "SendKyb",
  "RequestInfoModal" = "RequestInfoModal",
  "ApproveRFIModal" = "ApproveRFIModal",
  "AcceptTerms" = "AcceptTerms",
  "CreateApiKey" = "CreateApiKey",
  "CreateWebhook" = "CreateWebhook",
  "EditOrderModal" = "EditOrderModal",
  "OrderTimelineModal" = "OrderTimelineModal",
  "AcceptGeoLocation" = "AcceptGeoLocation",
  "UploadDocumentModal" = "UploadDocumentModal",
  "CreateLead" = "CreateLead",
  "CreateTazaEntity" = "CreateTazaEntity",
}

export enum TimeFrameOptions {
  "1D" = "1D",
  "7D" = "7D",
  "1M" = "1M",
  "All" = "All",
}

export enum CcyConversionOrderStatus {
  "QUOTE_ACCEPTED" = "QUOTE_ACCEPTED",
  "SRC_CCY_RETURNED" = "SRC_CCY_RETURNED",
  "SRC_CCY_RECEIVED" = "SRC_CCY_RECEIVED",
  "CCY_CONVERSION_PENDING" = "CCY_CONVERSION_PENDING",
  "INTERMEDIATE_TX_PENDING" = "INTERMEDIATE_TX_PENDING",
  "INTERMEDIATE_TX_SENT" = "INTERMEDIATE_TX_SENT",
  "DEST_CCY_TRANSFER_PENDING" = "DEST_CCY_TRANSFER_PENDING",
  "CANCELLED_BY_MM" = "CANCELLED_BY_MM",
  "CANCELLED_SLIPPAGE" = "CANCELLED_SLIPPAGE",
  "STOPPED_FATAL_ERROR" = "STOPPED_FATAL_ERROR",
  "REQUIRES_ACTION" = "REQUIRES_ACTION",
  "RETURNED_TO_RIDIAN" = "RETURNED_TO_RIDIAN",
  "RETURNED_TO_SENDER" = "RETURNED_TO_SENDER",
  "COMPLETE" = "COMPLETE",
  "NONE" = "NONE",
  "UNDER_REVIEW" = "UNDER_REVIEW",
  "CANCELLATION_REQUESTED" = "CANCELLATION_REQUESTED",
  "SRC_CCY_SENT" = "SRC_CCY_SENT",
  "DEST_CCY_RECEIVED" = "DEST_CCY_RECEIVED",
}

export const CcyConversionOrderStatusTranslation = {
  [CcyConversionOrderStatus["INTERMEDIATE_TX_PENDING"]]: "",
  [CcyConversionOrderStatus["CANCELLATION_REQUESTED"]]:
    "Cancellation Requested",
  [CcyConversionOrderStatus["QUOTE_ACCEPTED"]]: "Quote Accepted",
  [CcyConversionOrderStatus["DEST_CCY_TRANSFER_PENDING"]]:
    "Destination Bank Payout",
  [CcyConversionOrderStatus["COMPLETE"]]: "Completed",
  [CcyConversionOrderStatus["CANCELLED_BY_MM"]]: "Cancelled by MM",
  [CcyConversionOrderStatus["CCY_CONVERSION_PENDING"]]: "CCY Conversion",
  [CcyConversionOrderStatus["STOPPED_FATAL_ERROR"]]: "Fatal error",
  [CcyConversionOrderStatus["INTERMEDIATE_TX_SENT"]]: "Await",
  [CcyConversionOrderStatus["SRC_CCY_RECEIVED"]]: "Source CCY Received",
};

export const OrderStatusStepOptions = {
  [CcyConversionOrderStatus["QUOTE_ACCEPTED"]]: 4,
  [CcyConversionOrderStatus["DEST_CCY_TRANSFER_PENDING"]]: 4,
  [CcyConversionOrderStatus["COMPLETE"]]: 4,
  [CcyConversionOrderStatus["CANCELLED_BY_MM"]]: 0,
  [CcyConversionOrderStatus["CCY_CONVERSION_PENDING"]]: 4,
  [CcyConversionOrderStatus["STOPPED_FATAL_ERROR"]]: 0,
  [CcyConversionOrderStatus["INTERMEDIATE_TX_SENT"]]: 0,
  [CcyConversionOrderStatus["SRC_CCY_RECEIVED"]]: 0,
  [CcyConversionOrderStatus["INTERMEDIATE_TX_PENDING"]]: 0,
};

export const PlaceOrderPageTitleOptions = {
  [CcyConversionOrderStatus["NONE"]]: "Place Order",
  [CcyConversionOrderStatus["QUOTE_ACCEPTED"]]: "Processing Order",
  [CcyConversionOrderStatus["DEST_CCY_TRANSFER_PENDING"]]: "Processing Order",
  [CcyConversionOrderStatus["COMPLETE"]]: "Order Completed",
  [CcyConversionOrderStatus["CANCELLED_BY_MM"]]: "Place Order",
  [CcyConversionOrderStatus["CCY_CONVERSION_PENDING"]]: "Processing Order",
  [CcyConversionOrderStatus["STOPPED_FATAL_ERROR"]]: "Fatal error",
  [CcyConversionOrderStatus["INTERMEDIATE_TX_SENT"]]: "Place Order",
  [CcyConversionOrderStatus["SRC_CCY_RECEIVED"]]: "Source CCY Received",
  [CcyConversionOrderStatus["INTERMEDIATE_TX_PENDING"]]: "",
};

export enum DestinationAccountStatus {
  "APPROVED" = "APPROVED",
  "AUTOMATIC_REVIEW_PENDING" = "AUTOMATIC_REVIEW_PENDING",
  "IN_REVIEW" = "IN_REVIEW",
  "INFO_REQUESTED" = "INFO_REQUESTED",
  "INFO_SUBMITTED" = "INFO_SUBMITTED",
  "DISABLED" = "DISABLED",
  "REJECTED" = "REJECTED",
}

export enum BankAccountNumberByTransactionType {
  "NONE" = "Destination Bank Account",
  "SPID" = "CLABE",
  "UsDomesticWire" = "Account Number",
  "CryptoWallet" = "Wallet Address",
}

export enum TransactionTypeOptions {
  "SPID" = "SPID",
  "UsDomesticWire" = "US Domestic Wire",
  "CryptoWallet" = "Crypto Wallet Transfer",
}

export enum DestinationBankAccountClassName {
  "SPID" = "SPID",
  "UsDomesticWire" = "UsDomesticWire",
  "CryptoWallet" = "CryptoWallet",
}

export enum CalizaSupportedFiat {
  "BRL" = "BRL",
}
export enum CalizaSupportedCrypto {
  "USDT" = "USDT",
  "USDC" = "USDC",
}

export enum CalizaSupportedCountry {
  "MX" = "MX",
  "PE" = "PE",
  "US" = "US",
}

export enum RioSupportedCrypto {
  "USDT" = "USDT",
}

export enum WebSocketEvents {
  initial_snapshot = "initial_snapshot",
  order_update = "order_update",
}

export type SpreadType = "bps";

export enum SpreadTargetType {
  "Rate" = "Rate",
  "Spread" = "Spread",
  "Market" = "Market",
}

export enum KYBStatus {
  "KYB_SENT" = "KYB_SENT",
  "SUBMITTED" = "SUBMITTED",
  "IN_REVIEW" = "IN_REVIEW",
  "INFO_REQUESTED" = "INFO_REQUESTED",
  "INFO_SUBMITTED" = "INFO_SUBMITTED",
  "AWAITING_PARTNER" = "AWAITING_PARTNER",
  "ON_SITE_VISIT" = "ON_SITE_VISIT",
  "PENDING_SIGNATURE" = "PENDING_SIGNATURE",
  "ACCEPTED" = "ACCEPTED",
  "EXPIRED" = "EXPIRED",
  "DENIED" = "DENIED",
}

export enum IDTypes {
  "INE",
  "passport",
}

export enum DocumentTypeEnum {
  "document_id" = "Pasaporte",
  "document_ine_anverso" = "INE por delante",
  "document_ine_reverso" = "INE por detrás",
  "constancias_situacion_fiscal" = "Constancia Situación Fiscal",
  "constancias_situacion_fiscal_sociedad" = "Constancia Situación Fiscal de la Sociedad",
  "acta_constitutiva" = "Acta Constitutiva",
  "poder_representante_legal" = "Poder Representante Legal",
  "cif" = "Constancia Situación Fiscal",
}

export enum SyntheticRouterSupportedFiat {
  "MexDolar" = "MexDolar",
}

export enum RouterSupportedFiat {
  "MXN" = "MXN",
  "USD" = "USD",
  "HKD" = "HKD",
  "CNY" = "CNY",
  "SGD" = "SGD",
  "JPY" = "JPY",
  "AUD" = "AUD",
  "NZD" = "NZD",
  "CHF" = "CHF",
  "EUR" = "EUR",
  "CAD" = "CAD",
  "DKK" = "DKK",
  "GBP" = "GBP",
  "NOK" = "NOK",
  "SEK" = "SEK",
}
export enum RouterSupportedCrypto {
  "USDT" = "USDT",
}

export enum RouterSupportedCountry {
  "MX" = "MX",
  "US" = "US",
}
export enum RouterSupportedSourceCountry {
  "MX" = "MX",
  "US" = "US",
}

export enum RouterSupportedDOCountry {
  "US" = "US",
  "MX" = "MX",
  "HK" = "HK",
  "CN" = "CN",
  "SG" = "SG",
  "JP" = "JP",
  "AU" = "AU",
  "NZ" = "NZ",
  "IT" = "IT",
  "KR" = "KR",
  "CH" = "CH",
}

export enum RouterTransferMethods {
  "SWIFT" = "SWIFT",
  "HK_CHATS" = "HK_CHATS",
  "HK_FPS" = "HK_FPS",
  "MX_SPID" = "MX_SPID",
  "MX_SPEI" = "MX_SPEI",
  "US_ACH" = "US_ACH",
  "US_WIRE" = "US_WIRE",
  "SEPA" = "SEPA",
}

export const ReapTransfers = [
  RouterTransferMethods["SWIFT"],
  RouterTransferMethods["HK_CHATS"],
  RouterTransferMethods["HK_FPS"],
  RouterTransferMethods["SEPA"],
];

export const RouterTransferMethodsTitle = {
  [RouterTransferMethods["SWIFT"]]: "SWIFT",
  [RouterTransferMethods["HK_CHATS"]]: "CHATS",
  [RouterTransferMethods["HK_FPS"]]: "FPS",
  [RouterTransferMethods["MX_SPID"]]: "SPID",
  [RouterTransferMethods["US_ACH"]]: "ACH",
  [RouterTransferMethods["US_WIRE"]]: "WIRE",
  [RouterTransferMethods["MX_SPEI"]]: "SPEI",
  [RouterTransferMethods["SEPA"]]: "SEPA",
};

export enum RouterBankAccountTypes {
  "CHECKING" = "CHECKING",
  "SAVINGS" = "SAVINGS",
}

export enum PaymentCategories {
  "CAPITAL_INVESTMENT_OR_ITEM" = "CAPITAL_INVESTMENT_OR_ITEM",
  "OTHER" = "OTHER",
  "PAYMENT_FOR_BUSINESS_SERVICES" = "PAYMENT_FOR_BUSINESS_SERVICES",
  "PAYMENT_FOR_GOODS" = "PAYMENT_FOR_GOODS",
  "PAYMENT_FOR_SALARY_OR_BENEFITS" = "PAYMENT_FOR_SALARY_OR_BENEFITS",
}

export const paymentCategories: Array<PaymentCategories> = [
  PaymentCategories.CAPITAL_INVESTMENT_OR_ITEM,
  PaymentCategories.PAYMENT_FOR_BUSINESS_SERVICES,
  PaymentCategories.PAYMENT_FOR_GOODS,
  PaymentCategories.PAYMENT_FOR_SALARY_OR_BENEFITS,
  PaymentCategories.OTHER,
];

export enum ValidEvents {
  "order.updated" = "order.updated",
}

export enum ICCYOptions {
  "CCY_DEST" = "CCY_DEST",
  "CCY_SOURCE" = "CCY_SOURCE",
}

export enum RFIType {
  "INVOICE" = "INVOICE",
  "CONTRACT" = "CONTRACT",
  "BUSINESS_FORMATION" = "BUSINESS_FORMATION",
  "PROOF_OF_ADDRESS" = "PROOF_OF_ADDRESS",
  "RECEIPT" = "RECEIPT",
  "OTHER" = "OTHER",
}

export type tabs = "user" | "client" | "broker";

// Lead lifecycle for the pre-onboarding CRM. A lead must reach READY
// (all required qualification fields complete) before the onboarding
// link can be created; LINK_ISSUED hands off to the KYB flow.
export enum LeadStatus {
  "NEW" = "NEW",
  "CONTACTED" = "CONTACTED",
  "QUALIFYING" = "QUALIFYING",
  "READY" = "READY",
  "LINK_ISSUED" = "LINK_ISSUED",
}

// Compliance pre-screen outcome derived from the lead's declared industry.
// Informational only — flags the lead for manager/compliance attention,
// never auto-declines (decisions stay with Compliance).
export enum LeadIndustryFlag {
  "PROHIBITED" = "PROHIBITED",
  "HIGH_RISK" = "HIGH_RISK",
}

// Result of the pre-lead duplicate check against the platform. Tells the
// broker how far a company has already travelled through the funnel — WITHOUT
// disclosing which broker or group owns it (see the registry_check contract in
// leads_api). Precedence, highest first: an already-onboarded active client
// beats an in-flight KYB, which beats a still-open lead.
export enum ClientRegistryMatch {
  "NONE" = "NONE",
  "EXISTING_LEAD" = "EXISTING_LEAD",
  "ONBOARDING_IN_PROGRESS" = "ONBOARDING_IN_PROGRESS",
  "ACTIVE_CLIENT" = "ACTIVE_CLIENT",
}

export enum ClientType {
  "CORPORATE_ENTITY" = "CORPORATE_ENTITY",
  "INDIVIDUAL_WITH_BUSINESS_ACTIVITY" = "INDIVIDUAL_WITH_BUSINESS_ACTIVITY",
}

export enum SettlementType {
  "SPOT" = "SPOT",
  "FORWARD_24H" = "FORWARD_24H",
  "FORWARD_48H" = "FORWARD_48H",
  "FORWARD_72H" = "FORWARD_72H",
  "FORWARD_96H" = "FORWARD_96H",
}

export enum OrderType {
  "CRYPTO_RAIL" = "CRYPTO_RAIL",
  "FIAT_RAIL" = "FIAT_RAIL",
  "MEX_DIVISA" = "MEX_DIVISA",
  "MANUAL" = "MANUAL",
}

export enum ClientUserType {
  "BROKER" = "BROKER",
  "CORPORATE_ENTITY" = "CORPORATE_ENTITY",
  "INDIVIDUAL_WITH_BUSINESS_ACTIVITY" = "INDIVIDUAL_WITH_BUSINESS_ACTIVITY",
}

export enum ClientStatuses {
  "ACTIVE" = "ACTIVE",
  "OPS_HOLD" = "OPS_HOLD",
  "COMPLIANCE_HOLD" = "COMPLIANCE_HOLD",
  "INACTIVE" = "INACTIVE",
}

export type OrderMode = "standard" | "mexdolar";
